// Func = limiting Scope for this file
var lastScrollTop = 0;

if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

(function(){

    let itemsMenu = document.querySelectorAll('.privary-navigation .privary-navigation__item');
	itemsMenu.forEach((itemMenu)=>{
		if(itemMenu.querySelector('.submenu')){
			itemMenu.addEventListener('mouseenter',()=>{
				itemMenu.classList.add('hover');
				itemMenu.querySelector('.submenu').classList.add('show');
			});
			itemMenu.addEventListener('mouseleave',()=>{
				itemMenu.classList.remove('hover');
				itemMenu.querySelector('.submenu').classList.remove('show');
			})
		}
	})

    window.onload = function() {
		scrollW();
		window.addEventListener('scroll', function(){
			scrollW();
		})
	};

    // Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));

	//email signup animation 
	if(document.getElementById('email-signup')){
		document.getElementById('email-signup_FNAME').addEventListener('focus', function(){
			this.parentElement.classList.add('moved');
		})
		document.getElementById('email-signup_LNAME').addEventListener('focus', function(){
			this.parentElement.classList.add('moved');
		})
		document.getElementById('email-signup_email_address').addEventListener('focus', function(){
			this.parentElement.classList.add('moved');
		})

	}

    //CMS forms label animation
	if(document.getElementsByClassName('form-module__field').length > 0){
		let allffields = document.getElementsByClassName('form-module__field');
		
        for(let j = 0; j < allffields.length; j++){
            
            if(allffields[j].getElementsByTagName('input').length > 0){
                if(allffields[j].getElementsByTagName('input')[0].type.toLowerCase() != 'checkbox' && allffields[j].getElementsByTagName('input')[0].type.toLowerCase() != 'radio'){
                    allffields[j].getElementsByTagName('input')[0].addEventListener('focus', function(){
                        this.parentElement.classList.add('moved');
                    })
                }
            }
            if(allffields[j].getElementsByTagName('select').length > 0){
                allffields[j].getElementsByTagName('select')[0].addEventListener('focus', function(){
                    this.parentElement.classList.add('moved');
                })
            }
            if(allffields[j].getElementsByTagName('textarea').length > 0){
                allffields[j].getElementsByTagName('textarea')[0].addEventListener('focus', function(){
                    this.parentElement.classList.add('moved');
                })
            }
        }
	}

	if(document.querySelector('.grid-quad')){
		let itemsGrid = document.querySelectorAll('.grid-quad__item:not(.swiper-slide)');

		itemsGrid.forEach((item)=>{
			item.addEventListener('click',(e)=>{
				itemsGrid.forEach((item2)=>{
					item2.classList.remove('active');
					item2.querySelector('.text').classList.add('hidden');
				})
				item.classList.add('active');
				setTimeout(() => {
					item.querySelector('.text').classList.remove('hidden');
				}, 400);
			})
		})
	}

	if(document.querySelector('section.location')){
		let pointsMap = document.querySelectorAll('.location__point');
		let pointsImage = document.querySelectorAll('.location__image');
		let lastPoint = null;

		pointsMap.forEach((point)=>{
			point.addEventListener('click', ()=>{
				if (point === lastPoint) return;
				let dataPoint = point.dataset.point;
				point.classList.add('active');
				if(lastPoint){
					lastPoint.classList.remove('active');
				}
				lastPoint = point;
				pointsImage.forEach((image)=>{
					image.classList.toggle('active', image.dataset.point == dataPoint);
				})
			})
		})

		pointsMap[0].click();
	}

	if(document.querySelector('.accordion')){
		document.querySelectorAll('.accordion').forEach((accordion) => {
			accordion.querySelectorAll('.js-accordion-title').forEach((itemHead) => {
				itemHead.addEventListener('click', (e) => {
					accordion.querySelectorAll('.js-accordion-item').forEach((item) => {
						if (itemHead.parentNode !== item) item.classList.remove('open');
					});
					itemHead.parentNode.classList.toggle('open');
				});
			});
		});
	}

	if(document.querySelector('.form-module-wrapper')){
		document.querySelectorAll('.form-module-wrapper').forEach((text) => {
			text.querySelector('.form-module').classList.add('animate-fade','top');
		});
	}

	if(document.querySelector('.text-modules-wrapper')){
		document.querySelectorAll('.text-modules-wrapper').forEach((text) => {
		text.querySelector('.text-modules').classList.add('animate-fade','top');
	});
	}

	if(document.querySelector('.global-sitemap')){
		document.querySelector('.global-sitemap').classList.add('animate-fade', 'top');
	}

	if(document.getElementById('galleryGrid')){
		document.getElementById('galleryGrid').classList.add('animate-fade', 'top');
	}

	document.querySelector('.navigation.overlay .close-menu').addEventListener('click', ()=>{
		document.getElementById('menu-mobile').classList.remove('show');
	})

	document.querySelector('.js-open-menu').addEventListener('click', ()=>{
		document.getElementById('menu-mobile').classList.add('show');
	})

})();

function scrollW(){
	//check scroll down or up for header styles
	let st = window.pageYOffset || document.documentElement.scrollTop;
	if(st > 80){
		if (st > lastScrollTop){
			// downscroll code
			if(!document.getElementById('header').classList.contains('down')){
				document.getElementById('header').classList.add('down');
				document.getElementById('header').classList.remove('up');
			}
		} else {
			// upscroll code
			if(!document.getElementById('header').classList.contains('up')){
				document.getElementById('header').classList.add('up');
				document.getElementById('header').classList.remove('down');
			}
		}
	} else {
		if(document.getElementById('header').classList.contains('up') || document.getElementById('header').classList.contains('down')){
			document.getElementById('header').classList.remove('up');
			document.getElementById('header').classList.remove('down');
		}
	}
	lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
}

// skip to content functionality
document.addEventListener('keyup', (event) => {
	if (event.key === 'Tab') {
    const skipLink = document.querySelector('.skip-to-content');
    if (!skipLink.hasBeenFocused) {
        skipLink.focus();
        skipLink.hasBeenFocused = true;
        }
    }
});